import React from 'react'
import ReactHtmlParser from 'react-html-parser';
import { getObject, priceStandardView } from '../../utils/useful';
import moment from 'jalali-moment';

class TableTextEditorInput extends React.Component {
    state = {
        data: ''
    }


    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (this.props.data != prevProps.data) {
            this.init()
        }
    }


    init() {

        // console.log("this.init")
        let data = this.props.data

        // console.log(data)
        if (data) {
            data = this.textVariableReplacer(this.props.fullData, data)
            if (data) {
                data = ReactHtmlParser(data)
            }
            this.setState({ data })
        }
    }

    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }





    textVariableReplacer = (data, content) => {

        if (content && typeof content == 'string') {

            let output = content

            let reg = new RegExp('\{\{(.*?)\}\}', 'g')

            let matches = content.match(reg)

            if (matches) {
                for (let index = 0; index < matches.length; index++) {
                    const match = matches[index];


                    let key = match.replace(/{/g, '').replace(/}/g, '')

                    if (this.props.headers) {
                        for (let j = 0; j < this.props.headers.length; j++) {
                            const header = this.props.headers[j];


                            if (key == header.information?.label || key == header.key) {


                                let value = getObject(data, header.key)
                                // console.log(data)
                                // console.log(header.key)


                                switch (header.type) {
                                    case "PriceInput":
                                        value = priceStandardView(value)
                                        break;

                                    case "NumberInput":
                                        value = priceStandardView(value)
                                        break;

                                    case "GlobalUserInput":
                                        value = this.populateUser(data, value)
                                        break;
                                    case "DurationInput":
                                        // console.log('valeuss DU', value)
                                        value = value ? (value[0] ?? '00') + ':' + (value[1] ?? '00') + ':' + (value[2] ?? '00') : '00:00:00'
                                        break;

                                    case "DateInput":
                                        let format = 'DD MMM YYYY'
                                        if (header.information?.showHour) {
                                            format = format + ' hh:mm'
                                        }
                                        if (moment(Number(this.props.data)).isValid()) {

                                        }
                                        value = moment(Number(value)).format(format)
                                        break;
                                    case "DateTimeInput": {
                                        let format = 'DD MMM YYYY'
                                        if (header.information?.showHour) {
                                            format = format + ' hh:mm'
                                        }
                                        if (moment(Number(this.props.data)).isValid()) {

                                        }
                                        if (value) {
                                            value = moment(Number(value)).format(format)
                                        }
                                        else {
                                            value = ''
                                        }
                                        break;
                                    }

                                    default:
                                        break;
                                }


                                let nreg = new RegExp(match, 'g')
                                output = output.replace(nreg, value)


                            }


                        }
                    }
                }
            }

            return output

        }

    }

    populateUser = (data, value) => {
        // console.log('dataaassadadas', data)

        // console.log('data[key]',data[key])
        let newValue
        data.populates.users.map((element) => {
            // console.log('data[key]',data [key])
            if (element._id == value) {
                newValue = element.fullname
            }
        })
        // console.log('valuevalue', newValue)
        return newValue
    }
    render() {

        let styleInfo = this.props.header?.information?.style

        return (
            <div className="w-100 h-100 " >

                <div style={{ border: "none", outline: "none", position: "relative", zIndex: 0, padding: styleInfo?.padding }} >

                    {this.state.data}

                </div>

            </div>
        )
    }
}

export default TableTextEditorInput;